import { render, staticRenderFns } from "./Advancesearch.vue?vue&type=template&id=21d965fc"
import script from "./Advancesearch.vue?vue&type=script&lang=js"
export * from "./Advancesearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports